(function (){
    'use strict';

    angular
        .module('invoices', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable',
            'ui.toggle',
            '720kb.tooltips'
        ]);
})();